import { createSlice } from "@reduxjs/toolkit";
import { ContractFunnelDto, FormulasContextDto, PricingModeEnum } from "api/pricing";
import { ContractFunnel, FunnelFilter, GuaranteesReferential } from "../../types/interfaces";
import { extraReducers } from "./extra-reducers";
import { reducers } from "./reducers";

export interface PricingState {
  riskId?: string,
  globalGuaranteesReferential: GuaranteesReferential,
  globalGuarantees: GuaranteesReferential,
  guaranteeLastResearchHash: string | null,
  filters: FunnelFilter[]
  funnels: ContractFunnelDto[]
  shoppingCart: ContractFunnel[]
  updatedContractFunnels: ContractFunnel[]
  contractFunnels: ContractFunnel[]
  /** Fee value received from the tunnel, by fee id: reference to know which fees the broker changed. */
  tunnelFeeValues: Record<string, number>
  /** Comparable products only, fixed formulas only, or both (from the comparator response). */
  mode: PricingModeEnum
  /** The file's person as the formula cards need it; null in classic mode. */
  formulasContext: FormulasContextDto | null
  contracts: any[]
  pendingUpdates: Record<string, boolean>;
  loading: {
    pricingPageLoading: boolean
    contractFunnelsLoading: boolean
    contractFunnelsPricesLoading: boolean
    quoteCreationLoading: boolean
  }
}

export const pricingSliceInitialState: PricingState = {
  globalGuaranteesReferential: {
    optional: [],
    mandatory: [],
  },
  globalGuarantees: {
    optional: [],
    mandatory: [],
  },
  guaranteeLastResearchHash: null,
  filters: [],
  funnels: [],
  shoppingCart: [],
  updatedContractFunnels: [],
  contractFunnels: [],
  tunnelFeeValues: {},
  mode: PricingModeEnum.Classic,
  formulasContext: null,
  contracts: [],
  pendingUpdates: {},
  loading: {
    pricingPageLoading: false,
    contractFunnelsLoading: false,
    contractFunnelsPricesLoading: false,
    quoteCreationLoading: false
  }
}

const pricingSlice = createSlice({
  name: 'pricing',
  initialState: pricingSliceInitialState,
  reducers: reducers,
  extraReducers: extraReducers
})

// Actions
export const {
  updateAllContractFunnelsItem,
  updateContractFunnelGuarantees,
  updateContractFunnelItem,
  updateGlobalGuarantees,
  toggleFilterItem,
  resetFilters,
  enableAllFilters,
  setFilterItem,
  setAllFilterItems,
  deleteUpdatedContractFunnel,
  addShoppingCartItem,
  removeShoppingCartItem,
  schedulePriceUpdate,
  clearPriceUpdate,
  resetShoppingCart,
  setGuaranteeLastResearchHash,
  clearGuaranteeLastResearchHash,
} = pricingSlice.actions

export default pricingSlice.reducer
